<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPageLoader"
      :color="loaderColor"
    ></loading>
    <div class="w-full" style="min-height: 300px;">
      <v-wait for="senderdetail">
        <half-circle-spinner
          style="display: block; margin: 125px auto 0"
          :animation-duration="1000"
          :size="60"
          color="#3d4852"
          slot="waiting"
        />
        <div id="user-view" class="flex flex-col bg-white rounded w-full pt-4">
          <div
            class="px-6 pt-1 pb-4 create-sender-header border-b border-grey-300"
          >
            <div class="text-xl text-lg font-bold">
              {{
                this.$t('frontend_groovemail_settings_integeration_settings')
              }}
            </div>
            <div class="text-grey-800 text-sm">
              {{
                this.$t(
                  'frontend_groovemail_settings_configure_integeration_settings'
                )
              }}
            </div>
          </div>
          <div class="relative p-6 pb-0">
            <div class="flex flex-col">
              <div class="flex flex-col mb-6">
                <label class="font-semibold text-sm text-grey-700 mb-2">{{
                  this.$t(
                    'frontend_groovemail_settings_integeration_settings_gateway_name'
                  )
                }}</label>
                <text-input
                  class="text-dark text-sm"
                  :validator="$v.model.gateway_name"
                  :attribute="
                    this.$t(
                      'frontend_groovemail_settings_integeration_settings_gateway_name'
                    )
                  "
                  v-model="model.gateway_name"
                  value="model.gateway_name"
                  :placeholder="
                    this.$t(
                      'frontend_groovemail_settings_integeration_settings_enter_gateway_name'
                    )
                  "
                />
              </div>

              <div class="flex flex-col mb-6">
                <label class="font-semibold text-sm text-grey-700 mb-2">{{
                  this.$t(
                    'frontend_groovemail_settings_integeration_settings_account_sid'
                  )
                }}</label>
                <text-input
                  class="text-dark text-sm"
                  :validator="$v.model.account_sid"
                  :attribute="
                    this.$t(
                      'frontend_groovemail_settings_integeration_settings_account_sid'
                    )
                  "
                  v-model="model.account_sid"
                  value="model.account_sid"
                  :placeholder="
                    this.$t(
                      'frontend_groovemail_settings_integeration_settings_enter_account_sid'
                    )
                  "
                />
              </div>

              <div class="flex flex-col mb-6">
                <label class="font-semibold text-sm text-grey-700 mb-2">{{
                  this.$t(
                    'frontend_groovemail_settings_integeration_settings_auth_token'
                  )
                }}</label>
                <text-input
                  class="text-dark text-sm"
                  :validator="$v.model.auth_token"
                  :attribute="
                    this.$t(
                      'frontend_groovemail_settings_integeration_settings_auth_token'
                    )
                  "
                  v-model="model.auth_token"
                  value="model.auth_token"
                  :placeholder="
                    this.$t(
                      'frontend_groovemail_settings_integeration_settings_enter_auth_token'
                    )
                  "
                />
              </div>

              <div class="flex flex-col mb-6">
                <label class="font-semibold text-sm text-grey-700 mb-2">{{
                  this.$t(
                    'frontend_groovemail_settings_integeration_settings_phone_number'
                  )
                }}</label>
                <VuePhoneNumberInput
                  v-if="this.pageType == 'edit'"
                  class="sms-sender-phone-input"
                  :border-radius="6"
                  :default-country-code="default_country_code"
                  :show-code-on-list="true"
                  v-model="model.phone_number"
                  @update="getPhoneData($event)"
                />
                <VuePhoneNumberInput
                  v-if="this.pageType == 'add'"
                  class="sms-sender-phone-input"
                  :border-radius="6"
                  :fetch-country="true"
                  :show-code-on-list="true"
                  v-model="model.phone_number"
                  @update="getPhoneData($event)"
                />
                <p
                  class="w-full error text-pink-dark mt-1 text-sm"
                  v-if="submitted && !this.phoneData.isValid"
                >
                  {{
                    this.$t(
                      'frontend_groovemail_settings_integeration_invalid_phone_number'
                    )
                  }}
                </p>
              </div>

              <div class="flex flex-col mb-6">
                <label class="font-semibold text-sm text-grey-700 mb-2">{{
                  this.$t(
                    'frontend_groovemail_settings_integeration_settings_test_phone_number_label'
                  )
                }}</label>
                <VuePhoneNumberInput
                  class="sms-sender-phone-input"
                  :border-radius="6"
                  :fetch-country="true"
                  :show-code-on-list="true"
                  v-model="model.test_phone_number"
                  @update="getTestPhoneData($event)"
                />
                <p
                  class="w-full error text-pink-dark mt-1 text-sm"
                  v-if="submitted && !this.testPhoneData.isValid"
                >
                  {{
                    this.$t(
                      'frontend_groovemail_settings_integeration_invalid_phone_number'
                    )
                  }}
                </p>
              </div>

              <div class="flex flex-col mb-6">
                <label class="font-semibold text-sm text-grey-700 mb-2">{{
                  this.$t(
                    'frontend_groovemail_settings_integeration_settings_default'
                  )
                }}</label>
                <gd-toggle
                  class="rounded-full"
                  :value="model.is_default"
                  @change="changedefault"
                />
              </div>
            </div>
            <div class="flex justify-end pb-6 create-sender-save-btn">
              <gd-button
                v-if="this.pageType == 'add'"
                class="h-10 btn-width px-4 btn-radius text-base font-semibold"
                size="large"
                primary
                :disabled="this.userCanMail ? false : true"
                @click="
                  userCanMail ? createIntegerations() : null
                "
                >{{ this.$t('frontend_save') }}</gd-button
              >
              <gd-button
                v-if="this.pageType == 'edit'"
                class="h-10 btn-width px-4 btn-radius text-base font-semibold"
                size="large"
                primary
                :disabled="this.userCanMail ? false : true"
                @click="userCanMail ? createIntegerations() : null"
                >{{ this.$t('frontend_update') }}</gd-button
              >
            </div>
          </div>
        </div>
      </v-wait>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
// import { mapGetters } from 'vuex';
import {
  required,
  minLength,
  maxLength,
} from 'vuelidate/lib/validators';

import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import themeConfig from './theme/themeConfig.js';
import showAlert from './components/sweet-alert-popup.js';

export default {
  middleware: 'auth',
  metaInfo() {
    return {
      title: this.$t('frontend_groovemail_settings_integeration_title'),
    };
  },
  props: {
    btnValue: {
      type: String,
      default: ''
    },
    senderId: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      default_country_code: 'GB',
      pageType: 'add',
      submitted: false,
      model: {
        gateway_name: '',
        account_sid: '',
        auth_token: '',
        phone_number: '',
        test_phone_number: '',
        is_default: 0,
      },
      phoneData: {
        countryCallingCode: '44',
        countryCode: 'GB',
        isValid: false,
      },
      testPhoneData: {
        countryCallingCode: '44',
        countryCode: 'GB',
        isValid: false,
      },
      fullPageLoader: true,
      isLoading: false,
      loaderColor: themeConfig.appPrimaryColor,
      genericUrl: `${window.config.apiUrl.split('/api')[0]}/api`,
      userCanMail: null,
    };
  },

  components: {
    Loading,
    VuePhoneNumberInput,
  },

  validations: {
    model: {
      gateway_name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(50),
      },
      account_sid: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(50),
      },
      auth_token: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(50),
      },
    },
  },

  methods: {
    getPhoneData(event) {
      if (event.countryCallingCode) {
        this.phoneData.countryCallingCode = event.countryCallingCode;
      }
      if (event.countryCode) {
        this.phoneData.countryCode = event.countryCode;
      }
      this.phoneData.isValid = event.isValid;
    },

    getTestPhoneData(event) {
      if (event.countryCallingCode) {
        this.testPhoneData.countryCallingCode = event.countryCallingCode;
      }
      if (event.countryCode) {
        this.testPhoneData.countryCode = event.countryCode;
      }
      this.testPhoneData.isValid = event.isValid;
    },

    changedefault() {
      this.model.is_default = this.model.is_default != 1 ? 1 : 0;
    },

    async createIntegerations() {
      this.submitted = true;
      this.$v.model.gateway_name.$touch();
      this.$v.model.account_sid.$touch();
      this.$v.model.auth_token.$touch();
      if (
        this.$v.model.gateway_name.$invalid ||
        this.$v.model.account_sid.$invalid ||
        this.$v.model.auth_token.$invalid ||
        !this.phoneData.isValid ||
        !this.testPhoneData.isValid
      ) {
        return false;
      } 
      if (this.model.phone_number === this.model.test_phone_number) {
        showAlert({
          iconType: 'alert-error',
          html : `<p class="text-sm text-deep-dark"> ${ this.$t('frontend_groovemail_create_twilio_integration_send_phone_test_phone_match') }</p>`,
          showCancelButton: false,
          showCloseButton: true,
          confirmButtonColor: '#fd6481',
          confirmButtonText: this.$t(
            'frontend_close'
          ),
        });
        return false;
      }
      const integerationData = {
        gateway_name: this.model.gateway_name,
        sid: this.model.account_sid,
        token: this.model.auth_token,
        country_code: `+${  this.phoneData.countryCallingCode}`,
        from_number: this.model.phone_number,
        is_default: this.model.is_default,
        country_symbol: this.phoneData.countryCode,
        testing_number_code: `+${  this.testPhoneData.countryCallingCode}`,
        testing_number: this.model.test_phone_number,
      };
      if (this.pageType == 'add') {
        this.showLoader();
        axios.post(`${this.genericUrl}/groovemail/sms-sender`, integerationData).then(
          (res) => {
            this.$emit("fetchSender");
            this.$root.$emit('modal-close', 'create-integeration-modal');
            this.hideLoader();
          },
          (err) => {
            if (err.response && err.response.status === 409) {
              showAlert({
                iconType: 'alert-error',
                html : `<p class="text-sm text-deep-dark"> ${ this.$t('frontend_groovemail_settings_integeration_sid_already_saved') }</p>`,
                showCancelButton: false,
                showCloseButton: true,
                confirmButtonColor: '#fd6481',
                confirmButtonText: this.$t(
                  'frontend_close'
                ),
              });
              this.hideLoader();
            } else if (err.response && err.response.status === 404) {
              showAlert({
                iconType: 'alert-error',
                html : `<p class="text-sm text-deep-dark">
                  ${ err.response.data && err.response.data.error
                    ? err.response.data.error
                    : this.$t('frontend_groovemail_settings_integeration_unsuccessful_account_verification') }
                </p>`,
                showCancelButton: false,
                showCloseButton: true,
                confirmButtonColor: '#fd6481',
                confirmButtonText: this.$t(
                  'frontend_close'
                ),
              });
              this.hideLoader();
            }
          }
        );
      } else if (this.pageType == 'edit') {
        this.showLoader();
        axios
          .put(`${this.genericUrl}/groovemail/sms-sender/${this.senderId}`, integerationData)
          .then(
            (res) => {
              this.$emit("fetchSender");
              this.$root.$emit('modal-close', 'create-integeration-modal');
              this.hideLoader();
            },
            (err) => {
              if (err.response && err.response.status === 409) {
                showAlert({
                  iconType: 'alert-error',
                  html : `<p class="text-sm text-deep-dark"> ${ this.$t('frontend_groovemail_settings_integeration_sid_already_saved') }</p>`,
                  showCancelButton: false,
                  showCloseButton: true,
                  confirmButtonColor: '#fd6481',
                  confirmButtonText: this.$t(
                    'frontend_close'
                  ),
                });
                this.hideLoader();
              } else if (err.response && err.response.status === 404) {
                showAlert({
                  iconType: 'alert-error',
                  html : `<p class="text-sm text-deep-dark">
                    ${ err.response.data && err.response.data.error
                      ? err.response.data.error
                      : this.$t('frontend_groovemail_settings_integeration_unsuccessful_account_verification') }
                  </p>`,
                  showCancelButton: false,
                  showCloseButton: true,
                  confirmButtonColor: '#fd6481',
                  confirmButtonText: this.$t(
                    'frontend_close'
                  ),
                });
                this.hideLoader();
              }
            }
          );
      }
    },

    async createNewSmsSender() {
      this.submitted = true;
      this.$v.model.gateway_name.$touch();
      this.$v.model.account_sid.$touch();
      this.$v.model.auth_token.$touch();
      if (
        this.$v.model.gateway_name.$invalid ||
        this.$v.model.account_sid.$invalid ||
        this.$v.model.auth_token.$invalid ||
        !this.phoneData.isValid ||
        !this.testPhoneData.isValid
      ) {
        return false;
      } 
      if (this.model.phone_number === this.model.test_phone_number) {
        showAlert({
          iconType: 'alert-error',
          html : `<p class="text-sm text-deep-dark"> ${ this.$t('frontend_groovemail_create_twilio_integration_send_phone_test_phone_match') }</p>`,
          showCancelButton: false,
          showCloseButton: true,
          confirmButtonColor: '#fd6481',
          confirmButtonText: this.$t(
            'frontend_close'
          ),
        });
        return false;
      }
      const integerationData = {
        gateway_name: this.model.gateway_name,
        sid: this.model.account_sid,
        token: this.model.auth_token,
        country_code: `+${  this.phoneData.countryCallingCode}`,
        from_number: this.model.phone_number,
        is_default: this.model.is_default,
        country_symbol: this.phoneData.countryCode,
        testing_number_code: `+${  this.testPhoneData.countryCallingCode}`,
        testing_number: this.model.test_phone_number,
      };
      if (this.pageType == 'add') {
        this.showLoader();
        axios.post(`${this.genericUrl}/groovemail/sms-sender`, integerationData).then(
          (res) => {
            this.$emit('smsSenderCreated', res.data);
            this.hideLoader();
          },
          (err) => {
            if (err.response && err.response.status === 409) {
              showAlert({
                iconType: 'alert-error',
                html : `<p class="text-sm text-deep-dark"> ${ this.$t('frontend_groovemail_settings_integeration_sid_already_saved') }</p>`,
                showCancelButton: false,
                showCloseButton: true,
                confirmButtonColor: '#fd6481',
                confirmButtonText: this.$t(
                  'frontend_close'
                ),
              });
              this.hideLoader();
            } else if (err.response && err.response.status === 404) {
              showAlert({
                iconType: 'alert-error',
                html : `<p class="text-sm text-deep-dark">
                  ${ err.response.data && err.response.data.error
                    ? err.response.data.error
                    : this.$t('frontend_groovemail_settings_integeration_unsuccessful_account_verification') }
                </p>`,
                showCancelButton: false,
                showCloseButton: true,
                confirmButtonColor: '#fd6481',
                confirmButtonText: this.$t(
                  'frontend_close'
                ),
              });
              this.hideLoader();
            }
          }
        );
      }
    },

    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },

    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },
  },

  async created() {
    this.$wait.start('senderdetail');
    const dashboardData = await axios.get(`${this.genericUrl}/groovemail/dashboard`);
    this.userCanMail = dashboardData.data.can_mail;
    if (this.senderId && this.btnValue == 'EditIntegeration') {
      const integerationData = await axios.get(
        `${this.genericUrl}/groovemail/sms-sender/${this.senderId}`
      );
      this.pageType = 'edit';
      this.model.gateway_name = integerationData.data.gateway_name;
      this.model.account_sid = integerationData.data.sid;
      this.model.auth_token = integerationData.data.token;
      this.model.phone_number = integerationData.data.from_number;
      this.model.is_default = integerationData.data.is_default;
      this.default_country_code = integerationData.data.country_symbol;
    }
    this.$wait.end('senderdetail');
  },
};
</script>
